require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioButtonContext = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/RadioButton/RadioButtonGroup.tsx";
var RadioButtonContext = React.createContext(null);
exports.RadioButtonContext = RadioButtonContext;

var RadioButtonGroup = function (_React$Component) {
  (0, _inherits2["default"])(RadioButtonGroup, _React$Component);

  function RadioButtonGroup() {
    (0, _classCallCheck2["default"])(this, RadioButtonGroup);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RadioButtonGroup).apply(this, arguments));
  }

  (0, _createClass2["default"])(RadioButtonGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onValueChange = _this$props.onValueChange,
          children = _this$props.children;
      return React.createElement(RadioButtonContext.Provider, {
        value: {
          value: value,
          onValueChange: onValueChange
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68
        }
      }, children);
    }
  }]);
  return RadioButtonGroup;
}(React.Component);

(0, _defineProperty2["default"])(RadioButtonGroup, "displayName", 'RadioButton.Group');
var _default = RadioButtonGroup;
exports["default"] = _default;